import { Typography } from '@mui/material';
import type { FC } from 'react';

const GroupNames: FC<{
  items: { id: number | undefined; name: string }[];
}> = ({ items }) => {
  return (
    <Typography variant="body1" noWrap color="grey.500">
      {items.map((item, index) => (
        <span key={item.id}>
          {item.name}
          {index < items.length - 1 ? ', ' : null}
        </span>
      ))}
    </Typography>
  );
};

export default GroupNames;
